export const defaultContent = {
  paths: [{},{}]
}
export const numPathsOptions = [
  {
    value: 1,
    label: 1
  },
  {
    value: 2,
    label: 2
  },
  {
    value: 3,
    label: 3
  }
]
export const answerChoiceFormatOptions = [
  {
    value: "text",
    label: "Text"
  },
  {
    value: "image",
    label: "Image"
  }
]